import { alert } from "components/Alert"
import { toast } from "react-toastify"

export function formatNumber(value, decimals = 2) {
  return (value || 0).toLocaleString('pt-BR', { maximumFractionDigits: decimals, minimumFractionDigits: decimals })
}

function convertToDate(value) {
  if (value instanceof Date) return value
  return new Date(value)
}

export function formatDate(value) {
  return convertToDate(value).toLocaleDateString('pt-BR')
}

export function formatTime(value) {
  return convertToDate(value).toLocaleTimeString('pt-BR')
}

export function compareDate(date1, date2) {
  return convertToDate(date1).getTime() - convertToDate(date2).getTime()
}

export function formatDateTime(value) {
  return formatDate(value) + ' ' + formatTime(value)
}

export function onlyNumbers(value) {
  return value.replace(/[^\d]/gi, '')
}

export function onlyNumbersAndInitialMinus(value) {
  return value.replace(/[^-\d]/gi, '')
}

export function maskCNPJ(cnpj) {
  if (!cnpj)
    return ""

  const _cnpj = onlyNumbers(cnpj).substring(0, 14)
  return _cnpj
    .split('')
    .map((c, i) => {
      if (i === 2) return `.${c}`
      if (i === 5) return `.${c}`
      if (i === 8) return `/${c}`
      if (i === 12) return `-${c}`

      return c
    })
    .join('')
}

export function maskCPF(cpf) {
  if (!cpf)
    return ""

  const _cpf = onlyNumbers(cpf).substring(0, 11)
  return _cpf
    .split('')
    .map((c, i) => {
      if (i === 3) return `.${c}`
      if (i === 6) return `.${c}`
      if (i === 9) return `-${c}`

      return c
    })
    .join('')
}

export function maskDate(date) {
  if (!date)
    return ""

  const _date = onlyNumbers(date).substring(0, 8)
  return _date
    .split('')
    .map((c, i) => {
      if (i === 2) return `/${c}`
      if (i === 4) return `/${c}`

      return c
    })
    .join('')
}

export function maskPhone(phone) {
  if (!phone)
    return ""

  const _phone = onlyNumbers(phone).substring(0, 12)
  return _phone
    .split('')
    .map((c, i) => {
      if (i === 0) return `(${c}`
      if (i === 2) return `) ${c}`
      if (_phone.length == 10 && i === 6) return `-${c}`
      if (_phone.length == 11 && i === 7) return `-${c}`

      return c
    })
    .join('')
}

export function maskCEP(cep) {
  if (!cep)
    return ""

  const _cep = onlyNumbers(cep).substring(0, 8)
  return _cep
    .split('')
    .map((c, i) => {
      if (i === 5) return `-${c}`

      return c
    })
    .join('')
}

export function maskBankAccount(bankAccount) {
  if (!bankAccount)
    return ""

  const _bankAccount = onlyNumbers(bankAccount)
  return _bankAccount
    .split('')
    .reverse()
    .map((c, i) => {
      if (i === 1) return `${c}-`

      return c
    })
    .reverse()
    .join('')
}

export function maior(lst) {
  return lst.sort().reverse()[0]
}

export function validateEmail(email) {
  var re = /\S+@\S+\.\S+/;
  return re.test(email);
}

export async function asyncMap(items, fn) {
  const mappedList = []
  for (const item of items) {
    mappedList.push(await fn(item))
  }
  return mappedList
}

export function removerGruposVazios(node) {
  for (const filho of node.filhos) {
    removerGruposVazios(filho)
    if (filho.itens.length == 0 && filho.filhos.length == 0)
      filho.apagar = true
  }
  node.filhos = node.filhos.filter(el => !el.apagar)
}

export function atualizarItensArvore(node, fnAtualizacao) {
  for (const filho of node.filhos) {
    atualizarItensArvore(filho, fnAtualizacao)
  }
  if (node.itens) {
    for (const item of node.itens) {
      fnAtualizacao(item)
    }
    node.itens = node.itens.filter(el => !el.apagar)
  }
}

export function extrairItensArvore(node) {
  // recebe um no com filhos que é uma coleção de grupos, cada grupo pode ter outros filhos (grupos) ou pode ter itens, nos grupos se trabalha recursivamente
  const lst = []
  function _extrair(node, pai) { // o próprio node é o pai dos filhos abaixo dele
    for (const filho of node.filhos) {
      _extrair(filho, { id: filho.id, codigo: filho.codigo, descricao: filho.descricao, pai })
    }
    if (node.itens) {
      for (const item of node.itens) {
        lst.push({ ...item, pai })
      }
    }
  }
  _extrair(node)
  return lst
}

export function deepClone(obj) {
  return JSON.parse(JSON.stringify(obj))
}

export function chave(...params) {
  return params.join('_')
}

export function aleatorioMinMax(min, max) {
  return Math.random() * (max - min) + min;
}

export function round(value, decimals = 2) {
  const mult = 10 ** decimals
  return Math.round(value * mult) / mult
}

export function erroInesperado() {
  toast('Ocorreu um erro inesperado. Tente novamente mais tarde')
}

export function createQS(...params) {
  const qs = new URLSearchParams()
  params.forEach(param => {
    if (param) {
      Object.keys(param).forEach(key => {
        if (param[key] !== undefined && param[key] !== null) {
          qs.append(key, param[key])
        }
      })
    }
  })
  return qs.toString()
}

export function breadCrumbGrupo(grupo) {
  const toString = (grupo) => `${grupo.codigo} - ${grupo.descricao}`
  const itens = []
  let item = grupo
  while (item) {
    itens.push(toString(item))
    item = item.grupo
  }
  return itens.reverse().join(' → ')
}

export function arvoreParaMatriz(grupo) {
  const itens = []
  let item = grupo
  while (item) {
    itens.push({ ...item })
    item = item.grupo
  }
  return itens
}

export function totalizar(values) {
  return values.reduce((acc, value) => acc + value, 0)
}

export const backgroundColorList = [
  'rgba(255, 99, 132, 1)',
  'rgba(54, 162, 235, 1)',
  'rgba(255, 206, 86, 1)',
  'rgba(75, 192, 192, 1)',
  'rgba(153, 102, 255, 1)',
  'rgba(255, 159, 64, 1)',
]

export const borderColorList = [
  'rgba(255, 99, 132, 1)',
  'rgba(54, 162, 235, 1)',
  'rgba(255, 206, 86, 1)',
  'rgba(75, 192, 192, 1)',
  'rgba(153, 102, 255, 1)',
  'rgba(255, 159, 64, 1)',
]

export function estiloPrioridade(prioridade, concluida) {
  // SDD 037 - OS sem prioridade (NULL ou ''): estilo neutro, sem piscar
  if (!prioridade)
    return { background: '#e9ecef', color: '#6c757d' }

  const piscar = !concluida ? { animation: 'pulsar 2s infinite' } : null

  if (prioridade == 'P-1' || prioridade == 'PREF PRES')
    return { background: 'red', color: 'white', ...piscar }
  if (prioridade == 'P-2')
    return { background: 'yellow', color: 'black' }
  if (prioridade == 'P-3')
    return { background: 'green', color: 'white' }
}

export function adicionarApiUrl(url) {
  if (!url) return url
  return (process.env.REACT_APP_API_URL + url)
}